import React, { useState, useEffect } from "react";
import "../styles/VerificarEmail.css";

function VerificarEmail() {
  const [status, setStatus] = useState('inicial');
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    
    // Se não houver token, definir status como 'sem-token'
    if (!token) {
      setStatus('sem-token');
      setMensagem('Nenhum token de verificação encontrado.');
      return;
    }

    const verificarToken = async () => {
      setStatus('verificando');
      try {
        const response = await fetch(`${process.env.REACT_APP_DOMINIO_URL}users/verify-email?token=${token}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        const data = await response.json();
    
        if (response.ok) {
          setStatus('sucesso');
          setMensagem(data.message || 'Seu email foi verificado com sucesso! Agora você pode fazer login.');
        } else {
          setStatus('erro');
          setMensagem(data.message || data.error || 'Erro ao verificar seu email. O token pode ser inválido ou expirado.');
        }
      } catch (error) {
        setStatus('erro');
        setMensagem('Ocorreu um erro ao comunicar com o servidor.');
      }
    };

    verificarToken();
  }, []);

  return (
    <div className="verificar-email-container">
      <h1>Verificação de Email</h1>
      
      {status === 'inicial' && (
        <div className="loading">
          <p>Preparando verificação...</p>
        </div>
      )}

      {status === 'sem-token' && (
        <div className="erro">
          <h2>Token de Verificação Ausente</h2>
          <p>Não foi possível identificar um token de verificação na URL.</p>
          <p>Por favor, clique no link enviado para seu e-mail ou solicite um novo link de verificação.</p>
          <button onClick={() => window.location.href = '/login'}>
            Voltar para Login
          </button>
        </div>
      )}
      
      {status === 'verificando' && (
        <div className="loading">
          <p>Verificando seu email...</p>
          {/* Spinner de carregamento aqui */}
        </div>
      )}
      
      {status === 'sucesso' && (
        <div className="sucesso">
          <h2>Verificado com Sucesso!</h2>
          <p>{mensagem}</p>
          <button onClick={() => window.location.href = '/login'}>
            Ir para Login
          </button>
        </div>
      )}
      
      {status === 'erro' && (
        <div className="erro">
          <h2>Ocorreu um problema</h2>
          <p>{mensagem}</p>
          <button onClick={() => window.location.href = '/contato'}>
            Contatar Suporte
          </button>
        </div>
      )}
    </div>
  );
}

export default VerificarEmail;